function returnOptions(data, Count) {
  // 定义颜色
  const colorList = [{
    c1: '#FE6D6C',
  },
  {
    c1: '#47D09C',
  },
  {
    c1: '#FF9348',
  },
  {
    c1: '#B177F2',
  },
  {
    c1: '#FDD451',
  },
  ];
  // 重定义套餐销售数量
  const everyResult = data.map((item) => item.saleProportion);
  // 重定义套餐名称
  const name = data.map((item) => item.vipCardName);
  // num
  // const num = data.map((item) => item.num);
  return {
    title: {
      text: `套餐销售总数量：${Count}`,
      textStyle: {
        fontSize: 14
      },
      padding: 10,
      left: '8%',
      top: '2%',
    },
    grid: { // 直角坐标系内绘图网格
      left: '8%',
      right: '13%',
      bottom: '3%',
      top: '20%',
      containLabel: true
    },
    yAxis: {
      type: 'category',
      inverse: true, // 倒叙
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        interval: 0,
        formatter(value) {
          if (value.length > 7) {
            return `${value.slice(0, 6)}...`;
          }
          return value;
        },
        fontSize: 13,
        color: '#999',

      },
      data: name // 类目数据，在类目轴（type: 'category'）中有效。
    },
    xAxis: {
      type: 'value',
      splitLine: {
        show: false
      }, // 坐标轴在 grid 区域中的分隔线
      axisLabel: {
        show: false
      }, // 坐标轴刻度标签
      axisTick: {
        show: false
      }, // 坐标轴刻度
      axisLine: {
        show: false
      }, // 坐标轴轴线
    },
    series: [ // 系列列表。每个系列通过 type 决定自己的图表类型
      {
        name: '套餐销售占比', // 系列名称
        type: 'bar', // 柱状、条形图
        barWidth: 19, // 柱条的宽度,默认自适应
        data: everyResult, // 系列中数据内容数组
        label: { // 图形上的文本标签
          normal: {
            position: ['103%', -10],
            // position: 'insideTop',
            show: true,
            textStyle: {
              color: '#333', // 标签字体颜色
              fontSize: 13, // 标签字号,
            },
            formatter: '\n{c}%'
          }
        },
        itemStyle: { // 图形样式
          normal: {
            color(params) {
              return colorList[params.dataIndex].c1;
            },
          }
        },
      },
      // {
      //     name: '进度条',
      //     type: 'bar',
      //     barGap: '-100%', //不同系列的柱间距离，为百分比。
      //     barWidth: 19,
      //     data: num,
      //     z: 0,
      //     itemStyle: {
      //         normal: {
      //             color: '#eee'
      //         },
      //         emphasis: { // 鼠标悬停
      //             color: '#eee', //柱条颜色
      //         },
      //     },
      // },

    ]
  };
}
export const staffS = returnOptions;
